import { UserProfile } from '@beelday/common'
import { FC } from 'react'
import { KnowledgeCheckStats } from './knowledge-check'
import KnowledgeCheckTrainerStageView from './presentation/stage/knowledge-check-trainer-stage-view'
import useParticipantOverview from './use-participant-overview'

type Props = {
	userProfile: UserProfile | undefined | null
	title: string
	maxDurationInSeconds?: number
	startTime?: Date
	stats: KnowledgeCheckStats
	onFinish: () => void
	onShowResults: () => void
}

/** The running knowledge check on the in-person stage, fed from the room's stats. */
const ConfiguredKnowledgeCheckStage: FC<Props> = ({ stats, ...view }) => {
	const { overview, profiles } = useParticipantOverview(stats)
	return (
		<KnowledgeCheckTrainerStageView
			{...view}
			overview={overview}
			profiles={profiles}
		/>
	)
}

export default ConfiguredKnowledgeCheckStage
